import clsx from 'clsx'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { REFERRAL_EMPTY_INFO } from '../const'
import styles from './styles.scss'

const ReferralHistoryEmptySection = ({ selectedTab, t }) => {
  const emptyInfo = REFERRAL_EMPTY_INFO[selectedTab]
  return (
    <div className="referral-history-empty">
      <style jsx>{styles}</style>
      <Icon src={emptyInfo.icon} size={40} />
      <span className={clsx(Typo.title3, 'referral-history-empty__title')}>
        {hasLocizeTranslation(t, emptyInfo.titleKey, emptyInfo.titleText)}
      </span>
      <span className={clsx(Typo.body2, 'referral-history-empty__subtitle')}>
        {hasLocizeTranslation(t, emptyInfo.subtitleKey, emptyInfo.subtitleText)}
      </span>
    </div>
  )
}

ReferralHistoryEmptySection.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default compose(
  connect((state) => ({
    selectedTab: state.referralHistory.selectedTab,
  })),
  withI18next(),
)(ReferralHistoryEmptySection)
